module.exports = __webpack_public_path__ + "static/10-e90e194dc208d7b4df9d7627710cee9f.jpg";